import React from 'react';
import { Card, Spinner, EmptyState, AlertCircle } from '@opendate-app/setlist';

export default function WhenTheyBuyCard({ insights, insightsError }) {
  const buckets = insights && insights.purchase_lead_time ? insights.purchase_lead_time : [];
  const hasData = buckets.some((bucket) => bucket.pct > 0);

  return (
    <Card padding="md">
      <h2 style={{ margin: '0 0 4px', fontSize: 18 }}>When they buy</h2>
      <p style={{ margin: '0 0 12px', fontSize: 12, color: 'var(--sl-text-quaternary, #717680)' }}>
        Purchase lead time before the event.
      </p>
      {insightsError ? (
        <EmptyState
          size="sm"
          icon={AlertCircle}
          title="Couldn't load purchase timing"
          description="Refresh the page to try again."
        />
      ) : !insights ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '24px 0' }}>
          <Spinner label="Loading…" />
        </div>
      ) : !hasData ? (
        <EmptyState size="sm" title="No purchase timing data yet" />
      ) : (
        buckets.map((bucket) => (
          <div key={bucket.label} style={{ padding: '8px 0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14, marginBottom: 4 }}>
              <span style={{ fontWeight: 600 }}>{bucket.label}</span>
              <span style={{ color: 'var(--sl-text-quaternary, #717680)' }}>{bucket.pct}%</span>
            </div>
            <div style={{ height: 6, borderRadius: 3, background: 'var(--sl-bg-secondary, #f2f4f7)' }}>
              <div
                style={{
                  height: '100%',
                  borderRadius: 3,
                  background: 'var(--sl-fg-brand)',
                  width: `${Math.min(bucket.pct, 100)}%`,
                }}
              />
            </div>
          </div>
        ))
      )}
    </Card>
  );
}
